module.exports = __webpack_public_path__ + "img/twitter_blue.b88817c8.svg";